import { useEffect, useState } from "react";
import BTBox from "../../components/BTBox";
import BTDialogBox from "../../components/BTDialgBox";
import EnhancedTable from "../../components/BTTable";
import BTTypography from "../../components/BTTypography";
import {
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  TextField,
} from "@mui/material";
import Error from "@mui/icons-material/Error";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import {
  get_submissions,
  get_results,
  get_replies,
  get_returns,
  get_parties,
} from "../../store/functions";
import authService from "../../services/auth-service";
import { useLoading, useNotification } from "../../context";
const SearchRecord = ({ selectedData, setSelectedData, parties }) => {
  const handleClose = () => {
    setSelectedData(null);
  };
  const columns = [
    {
      id: "type",
      name: "Type",
      selector: (row) => row?.source,
      width: "50px",
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "cust_ref_no",
      name: "Customer Ref No",
      selector: (row) => {
        if (row?.source === "submit") {
          return row?.stn_cus_ref_no;
        } else {
          return row?.customer_ref_no;
        }
      },
      width: "100px",
    },
    {
      id: "report_number",
      name: "Report Number",
      selector: (row) => {
        if (row?.source === "submit") {
          return row?.stn_report_no || "-";
        } else {
          return row?.report_number;
        }
      },
      width: "100px",
    },
    {
      id: "party",
      name: "Party",
      selector: (row) => {
        const party = parties?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) => {
        const party = parties?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_code;
      },
    },
    {
      id: "pcs",
      name: "Pcs",
      selector: (row) => {
        if (row?.source === "submit") {
          return row?.stn_pcs;
        } else {
          return row?.number_stones;
        }
      },
      width: "50px",
    },
    {
      id: "weigth",
      name: "Weigth",
      selector: (row) => {
        if (row?.source === "submit") {
          return row?.stn_cts;
        } else {
          return row?.weight;
        }
      },
      width: "50px",
    },
    {
      id: "color",
      name: "Color",
      selector: (row) => {
        if (row?.source === "submit") {
          return row?.stn_color;
        } else {
          return row?.color_short;
        }
      },
      width: "50px",
    },
    {
      id: "clarity",
      name: "Clarity",
      selector: (row) => {
        if (row?.source === "submit") {
          return "-";
        } else {
          return row?.clarity;
        }
      },
      width: "50px",
    },
    {
      id: "cut_prop",
      name: "Cut prop",
      selector: (row) => {
        if (row?.source === "submit") {
          return "-";
        } else {
          return row?.cut_prop;
        }
      },
      width: "50px",
    },
    {
      id: "pol_or_pol_sym",
      name: "POL or Pol/Sym",
      selector: (row) => {
        if (row?.source === "submit") {
          return "-";
        } else {
          return row?.pol_or_pol_sym;
        }
      },
      width: "50px",
    },
    {
      id: "sym",
      name: "Symatry",
      selector: (row) => {
        if (row?.source === "submit") {
          return "-";
        } else {
          return row?.sym;
        }
      },
      width: "50px",
    },
    {
      id: "recheck",
      name: "Recheck",
      selector: (row) => {
        if (row?.source === "submit") {
          return "-";
        } else {
          return row?.recheck;
        }
      },
    },
    {
      id: "date",
      name: "Date",
      selector: (row) => {
        if (row?.source === "submit") {
          return moment(row.stn_date, "YYYY-MM-DD").format("DD/MM/YYYY");
        } else if (row?.source === "result") {
          return moment(row.res_date, "YYYY-MM-DD").format("DD/MM/YYYY");
        } else if (row?.source === "reply") {
          return moment(row.rep_date, "YYYY-MM-DD").format("DD/MM/YYYY");
        } else {
          return moment(row.ret_date, "YYYY-MM-DD").format("DD/MM/YYYY");
        }
      },
      width: "150px",
    },
  ];

  return (
    <BTDialogBox
      open={Boolean(selectedData)}
      fullWidth
      maxWidth="xl"
      close={handleClose}
      title="Search Records"
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
      ]}>
      <EnhancedTable
        rows={selectedData}
        columns={columns}
        tableHeader
        pagination
      />
    </BTDialogBox>
  );
};
function useDebounce(value, delay = 1000) {
  const [debounceValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(id);
    };
  }, [value, delay]);
  return debounceValue;
}
const GlobalAutoComplete = () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata") || {};
  const submissions = useSelector((state) => state?.lab?.submissions);
  const results = useSelector((state) => state?.lab?.results);
  const replies = useSelector((state) => state?.lab?.replies);
  const labouts = useSelector((state) => state?.lab?.labouts);
  const parties = useSelector((state) => state?.lab?.parties);
  const [inputValue, setInputValue] = useState("");
  const debouncedSearchText = useDebounce(inputValue);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const handleChange = (e) => {
    const { value } = e.target;
    setInputValue(value);
  };

  const getSuggestions = async () => {
    setError(null);
    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await authService?.get_search_submissions({
        attributes: {
          search: debouncedSearchText,
          u_id,
          u_type,
          parent_u_id,
          admin_u_id: u_type === 1 ? u_id : admin_u_id,
        },
      });

      setSuggestions(response?.data);
    } catch (error) {
      setError("Failed to fetch!");
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  const highlightMatch = (text, query) => {
    if (!query || !text) return text;

    const index = text.toLowerCase().indexOf(query.toLowerCase());
    if (index === -1) return text;

    const before = text.substring(0, index);
    const match = text.substring(index, index + query.length);
    const after = text.substring(index + query.length);

    return (
      <>
        {before}
        <span style={{ fontWeight: "bold", color: "#1b7af5" }}>{match}</span>
        {after}
      </>
    );
  };

  const handleItemSelection = async (item) => {
    try {
      showLoading();
      setSelectedData(null);
      const response = await authService?.get_search_history({
        attributes: {
          stn_cus_ref_no: item?.stn_cus_ref_no,
          stn_report_no: item?.stn_report_no,
          u_id,
          u_type,
          parent_u_id,
          admin_u_id: u_type === 1 ? u_id : admin_u_id,
        },
      });
      setSelectedData(response?.data);
    } catch (error) {
      addNotification({
        message: error?.message?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } finally {
      hideLoading();
    }
    // Create an array to hold all related data
    // const relatedData = [];
    // // Add the submission data with type indicator
    // if (item) {
    //   relatedData.push({
    //     ...item,
    //     dataType: 1, // 1 for submission
    //     dataTypeName: "Submission",
    //   });
    // }
    // // Find matching results
    // const matchingResults = results?.data?.filter(
    //   (result) =>
    //     Number(result?.report_number) === Number(item?.stn_report_no) &&
    //     result?.res_type !== 1
    // );
    // matchingResults?.forEach((result) => {
    //   relatedData.push({
    //     ...result,
    //     dataType: 2, // 2 for result
    //     dataTypeName: "Result",
    //   });
    // });
    // // Find matching replies
    // const matchingReplies = replies?.data?.filter(
    //   (reply) =>
    //     Number(reply?.report_number) === Number(item?.stn_report_no) &&
    //     reply?.rep_type !== 1
    // );
    // matchingReplies?.forEach((reply) => {
    //   relatedData.push({
    //     ...reply,
    //     dataType: 3, // 3 for reply
    //     dataTypeName: "Reply",
    //   });
    // });
    // // Find matching labouts
    // const matchingLabouts = labouts?.data?.filter(
    //   (labout) =>
    //     Number(labout?.report_number) === Number(item?.stn_report_no) &&
    //     labout?.ret_type !== 1
    // );
    // matchingLabouts?.forEach((labout) => {
    //   relatedData.push({
    //     ...labout,
    //     dataType: 4, // 4 for labout
    //     dataTypeName: "Labout",
    //   });
    // });
    // setSelectedData(relatedData);
  };

  useEffect(() => {
    if (debouncedSearchText?.length > 0) {
      getSuggestions();
    } else {
      setSuggestions([]);
    }
    // !submissions?.is_fetch && get_submissions();
    // !results?.is_fetch && get_results();
    // !replies?.is_fetch && get_replies();
    // !labouts?.is_fetch && get_returns();
    !parties?.is_fetch && get_parties();
  }, [debouncedSearchText]);

  return (
    <BTBox p={2} bgColor={"white"} borderRadius="md" shadow="sm" mb={1}>
      <TextField
        fullWidth
        size="small"
        label="Search by Reference No or Report No"
        value={inputValue}
        onChange={handleChange}
        type="text"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      {error && <BTTypography color="error">{error}</BTTypography>}

      {loading && (
        <BTBox display="flex" justifyContent="center" mt={1}>
          <CircularProgress color="secondary" size={30} />
        </BTBox>
      )}

      {inputValue.length > 0 && !loading && (
        <List sx={{ maxHeight: 200, overflow: "auto", mt: 1 }}>
          {suggestions.length > 0 ? (
            suggestions.map((item, index) => (
              <ListItem
                key={index}
                button
                sx={{ p: 1, cursor: "pointer" }}
                onClick={() => handleItemSelection(item)}>
                <ListItemText
                  primary={
                    <div>
                      <div>
                        Customer Ref No:{" "}
                        {highlightMatch(item.stn_cus_ref_no, inputValue)}
                      </div>
                      <div>
                        Report No:{" "}
                        {highlightMatch(item.stn_report_no, inputValue)}
                      </div>
                    </div>
                  }
                  primaryTypographyProps={{ fontSize: "0.875rem" }}
                />
              </ListItem>
            ))
          ) : (
            <ListItem sx={{ p: 1 }}>
              <ListItemText
                primary="Not found"
                primaryTypographyProps={{ fontSize: "0.875rem" }}
              />
            </ListItem>
          )}
        </List>
      )}
      {selectedData && (
        <SearchRecord
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          parties={parties?.data}
        />
      )}
    </BTBox>
  );
};

export default GlobalAutoComplete;
